import React from "react";
import PropTypes from "prop-types";
import CustomizableStoryCard from "../../cards/customizable-story-card";

import { desktop1by1HorizontalH5 } from "../../cards/customizable-story-card/story-card.config";
import styles from "./styles.m.css";

const SixStoryOneBigStory = ({ items }) => {
  return (
    <div className={`${styles["four-story-half-featured"]} `}>
      <div className={`container`}>
        <div className={`${styles["story-grid"]} `}>
          {items &&
            items.length > 0 &&
            items.map((item, i) => (
              <CustomizableStoryCard
                key={item.id}
                className={styles["bottom-gap"]}
                story={Object.assign({}, item, { contributors: null })}
                desktop={Object.assign({}, desktop1by1HorizontalH5, { imageToHeadlineRatio: [4, 13] })}
                mobile={Object.assign({}, desktop1by1HorizontalH5, { imageToHeadlineRatio: [4, 13] })}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

SixStoryOneBigStory.propTypes = {
  accentColor: PropTypes.string,
  items: PropTypes.shape()
};
SixStoryOneBigStory.storyLimit = 6;

export default SixStoryOneBigStory;
